import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.customers')
  .config(customersConfig);

/* ngInject */
function customersConfig($stateProvider) {

  function _getCustomerName(customer) {
    return _.get(customer, 'firstName', '') + ' ' + _.get(customer, 'lastName', '');
  }

  $stateProvider

    // Customers
    .state('customers', {
      parent: 'bringoz.site',
      url: '/customers',
      template: '<customers-view></customers-view>',
      controller: function (triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Customers"});
        triBreadcrumbsService.addCrumb({name: "Shippers"});
      }
    })

    // Customer - Abstract
    .state('customer', {
      parent: 'bringoz.site',
      url: '/customer/:id',
      abstract: true,
      template: '<customer-view customer="customer"></customer-view>',
      controller: function ($scope, customer, $customers, site) {
        $scope.customer = customer;

        const customerRef = $customers(customer.id);
        customerRef.$bind($scope, 'customer');
        customerRef.$registerOnUpdateHandler($scope, (updatedCustomer) => {
          if (_.get(customer, 'id') === _.get(updatedCustomer, 'id')) {
            $scope.customer = updatedCustomer;
          }
        });
      },
      resolve: {
        customer: ($customers, $stateParams, site) => {
          return $customers($stateParams.id).$instantGet();
        }
      }
    })

    // Customer - Active Services
    .state('customer.active-deliveries', {
      url: '/active-deliveries',
      pageTrack: '/customer/active-deliveries',
      template: '<customer-active-deliveries-view customer="$ctrl.customer"></customer-active-deliveries-view>',
      controller: function (triBreadcrumbsService, customer) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Active Services"});
        triBreadcrumbsService.addCrumb({name: _getCustomerName(customer), ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Customers", state: 'customers'});
      }
    })

    // Customer - Services History
    .state('customer.delivery-history', {
      url: '/delivery-history',
      pageTrack: '/customer/delivery-history',
      template: '<customer-delivery-history-view customer="$ctrl.customer"></customer-delivery-history-view>',
      controller: function (triBreadcrumbsService, $scope, customer) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Services History"});
        triBreadcrumbsService.addCrumb({name: _getCustomerName(customer), ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Customers", state: 'customers'});
      }
    })

    // Customer - Addresses
    .state('customer.addresses', {
      url: '/addresses',
      pageTrack: '/customer/addresses',
      controllerAs: 'vm',
      template: '<customer-addresses-view customer="$ctrl.customer"></customer-addresses-view>',
      controller: function (triBreadcrumbsService, customer) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Addresses"});
        triBreadcrumbsService.addCrumb({name: _getCustomerName(customer), ignoreTranslate: true});
        triBreadcrumbsService.addCrumb({name: "Customers", state: 'customers'});
      }
    })

}
